import{jsx as o}from"react/jsx-runtime";import s from"../assets/menu-join.module.scss";import{useMenuContext as r}from"../hooks/index.js";const e=()=>{const{isOpen:n}=r();return n?o("span",{className:s.menuJoin}):null};export{e as Join};
